export enum AuthType {
  LineLeapAdmin,
  VenueAdmin,
  LineLeapRead,
  VenueRead
}
